// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleAndDescription_container__27NlN","title":"TitleAndDescription_title__zBN7E"};